import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 

@Component({
  selector: 'app-apply-info',
  templateUrl: './apply-info.component.html',
  styleUrls: ['./apply-info.component.scss']
})
export class ApplyInfoComponent implements OnInit {

  showMeBasvuru: boolean;
  showMeBasvuruTrue: boolean;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.router.navigate(['/anasayfa']);
  }
  handleSelectedBasvuru($event) {
    if ($event.target.checked === true) {
      this.showMeBasvuru = true;
      this.showMeBasvuruTrue =false;
    }
    else {
      this.showMeBasvuru = false;
      this.showMeBasvuruTrue =true;
    }
  }
  applyForm() { 
    if (this.showMeBasvuru) {
      this.router.navigate(['/basvuru-form']);
      console.log('fenerbahce'); 
      return;
    }
    else { 
      this.showMeBasvuruTrue = true;
    }
  }
}
